import { useAuth } from '../contexts/AuthContext';

export function usePermissions() {
  const { user } = useAuth();

  const hasRole = (role: string): boolean => {
    return user?.roles?.includes(role) ?? false;
  };

  const can = (permission: string): boolean => {
    return user?.permissions?.includes(permission) ?? false;
  };

  const isAdmin = hasRole('admin');

  return {
    hasRole,
    can,
    isAdmin,
    roles: user?.roles ?? [],
    permissions: user?.permissions ?? [],
  };
}
